import {Helmet} from '@dr.pogodin/react-helmet';
import {Box, Grid, GridItem, Heading, HStack, Image, Show, VStack} from 'platform/foundation';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {useGetOnlineOfferData} from '../../hooks/useGetOnlineOfferData';
import {getWorkspaceCustomization} from '../../utils/getWorkspaceCustomization';
import {makeStorageResizeUrl} from '../../utils/makeStorageResizeUrl';

const LOGO_WIDTH = 220 * 2;
const LOGO_HEIGHT = 44 * 2;
const HERO_PHOTOS_COUNT = 3;
const HERO_PHOTO_WIDTH = 400;

export function HeroPrint() {
  const {logo: applicationLogo} = getWorkspaceCustomization();
  const {saleVehiclePhotos, vehicle, tenantLogoUrl} = useGetOnlineOfferData();

  const resizedLogoUrl = tenantLogoUrl
    ? makeStorageResizeUrl(tenantLogoUrl, {
        width: LOGO_WIDTH,
        height: LOGO_HEIGHT,
        withoutEnlargement: true,
      })
    : undefined;

  const photosToShow = saleVehiclePhotos?.slice(0, HERO_PHOTOS_COUNT) ?? [];

  return (
    <Box width="100%" overflow="hidden" paddingHorizontal={10} paddingVertical={5}>
      <VStack spacing={10} width="100%" height="100%">
        <Helmet>
          <title>{vehicle?.title}</title>
        </Helmet>
        <HStack>
          {resizedLogoUrl ? <Image maxHeight={11} src={resizedLogoUrl} /> : applicationLogo}
        </HStack>
        <Heading size={1}>{vehicle?.title}</Heading>

        <Show when={isNotNilOrEmpty(photosToShow)}>
          <Grid columns={3} horizontalSpacing={2}>
            {photosToShow.map((photo) => (
              <GridItem key={photo.id}>
                <Image
                  fit="cover"
                  position="center"
                  ratio="3 / 2"
                  width="100%"
                  borderRadius="small"
                  src={makeStorageResizeUrl(photo.url, {width: HERO_PHOTO_WIDTH})}
                  alt={vehicle?.title}
                />
              </GridItem>
            ))}
          </Grid>
        </Show>
      </VStack>
    </Box>
  );
}
